import { Flex } from 'antd';
import React from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'shared/config/store/store';
import { RoundContainer } from 'shared/ui';
import DualBalance from 'shared/ui/DualBalance/DualBalance';
import {
  getUserSecureState,
  setUserSecure,
} from 'shared/config/store/reducers/userSlice';

type BalanceProps = {
  balance: number;
};

const Balance: React.FC<BalanceProps> = ({ balance }) => {
  const hide = useSelector(getUserSecureState);
  const dispatch = useDispatch<AppDispatch>();

  const toggleSecured = () => {
    dispatch(setUserSecure(!hide));
  };

  return (
    <Flex justify="space-between" align="flex-start" gap={16}>
      <DualBalance
        ledgerBalance={balance}
        secured={hide}
        size="xl"
        idPrefix={hide ? 'balance-hidden' : 'balance-shown'}
      />
      <RoundContainer
        id="#btn__show-balance"
        size={32}
        color={'rgba(0, 0, 0, 0.1)'}
        pointer
        onClick={toggleSecured}>
        {hide ? (
          <EyeOutlined style={{ fontSize: 20 }} />
        ) : (
          <EyeInvisibleOutlined style={{ fontSize: 20 }} />
        )}
      </RoundContainer>
    </Flex>
  );
};

export default Balance;
